"use client";

export function SatelliteErrorState({
  reset,
  homeHref = "/",
}: {
  reset: () => void;
  homeHref?: string;
}) {
  return (
    <div
      className="flex min-h-[60vh] items-center justify-center p-6"
      style={{
        backgroundColor: "var(--brand-background, #ffffff)",
        color: "var(--brand-text, #111827)",
      }}
    >
      <div className="max-w-md text-center" role="alert">
        <h1 className="text-2xl font-bold">We could not load this page</h1>
        <p className="mt-3 text-sm leading-6">
          Try the request again. If it still fails, return to the homepage.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <button
            type="button"
            onClick={reset}
            className="min-h-11 rounded-md border px-4 py-2 text-sm font-medium"
            style={{ borderColor: "var(--brand-card-border, #d1d5db)" }}
          >
            Retry
          </button>
          <a
            href={homeHref}
            className="inline-flex min-h-11 items-center rounded-md border px-4 py-2 text-sm font-medium"
            style={{ borderColor: "var(--brand-card-border, #d1d5db)" }}
          >
            Go to homepage
          </a>
        </div>
      </div>
    </div>
  );
}
